<template>
    <div>
        <div>
            <div class="head_title">
                <my-head />
            </div>
            <div class="head_search">
                <global-search-bar class="search"/>
            </div>
            <div class="head_background"></div>
            <div class="body-box">
                <!-- 侧边导航栏-->
                <div class="sidebar">
                    <div
                        v-for="(item, index) in sidebarData"
                        :key="index"
                        :style="item.boxStyle"
                    >
                        <div class="sidebar_item" @click="clickSidebarItem(index)">
                            <span :style="item.iconStyle" ></span>
                            <span class="sidebar_item_title" >
                                <span :style="item.titleStyle">{{item.title}}</span>
                            </span>
                        </div>

                    </div>

                </div>
                <!-- 内容-->
                <div class="content_box">
<!--                    &lt;!&ndash; 数字听书，单独拎出来 &ndash;&gt;-->
<!--                    <audio-book v-if="currentComponent === 'audioBook'"/>-->
                    <!-- 课堂教学，单独拎出来 -->
                    <lessons v-if="currentComponent === 'lessons'"/>
                    <movies v-else-if="currentComponent === 'items-movies'"/>
                    <template v-else>
                        <component :is="currentComponent"
                                   v-for="(item, index) in contentData"
                                   :key="index"
                                   :item-prop="item"
                        />
                    </template>

                </div>
            </div>

        </div>


        <div class="bottom_guidebar"></div>


    </div>
</template>


<script>

import search from '@/components/searchBar'
import myHead from '@/components/myHeader'
import {getSideBarData} from '@/api/CommonApi'
import {getTopic} from "@/api/CommonApi";
import audioBook from '../../components/columns/audioBook'
import lessons from '../../components/columns/lessons'
import paints from "../../components/columns/paints";
import stories from "../../components/columns/stories";
import Movies from "@/components/columns/movies";
import GlobalSearchBar from "@/components/globalSearchBar";

export default{
    name: 'column',
    components:{
        GlobalSearchBar,
        myHead,
        search,
        audioBook,
        stories,
        paints,
        lessons,
        Movies
    },
    data(){
        return{
            sidebarData:[],  //侧边导航栏数据
            contentData:[],   //内容数据
            isSidebarItem: 0,  //选中的侧边导航栏
            currentComponentArray:['audioBook', 'stories', 'paints', 'lessons','items-movies'],
            currentComponent:'',
        }
    },
    created(){
        //获取侧边栏
        getSideBarData().then(res => {
            this.sidebarData = res.result || [];
            this.isSidebarItem = 0;
            this.currentComponent = this.currentComponentArray[this.isSidebarItem];
            this.initSidebarItem();
            let code = this.sidebarData[this.isSidebarItem].code;
            console.log('code = ', code);
            this.getContentData(code);
        }).catch(err => {
            console.log(err)
        })
    },

    methods: {
        //刷新选中的侧边菜单样式
        initSidebarItem(){
            for(let i = 0; i < this.sidebarData.length; i++){
                const item = this.sidebarData[i];
                item.boxStyle = {};
                item.iconStyle = {};
                item.titleStyle = {};
                if(this.isSidebarItem === i){
                    item.boxStyle = {backgroundColor : '#FFFFFF'};
                    item.iconStyle = {height: '20px',
                                      border : '2px solid RGBA(94, 174, 236, 1)',
                                      borderRadius : '4px'
                                      }
                    item.titleStyle = {color : 'RGBA(94, 174, 236, 1)'}
                }
            }
        },

        clickSidebarItem(index){
            this.isSidebarItem = index || 0;
            this.currentComponent = this.currentComponentArray[this.isSidebarItem];
            this.initSidebarItem();
            let code = this.sidebarData[index].code;
            this.contentData = this.getContentData(code) || {};
        },

        //根据侧边栏code拉取对应数据
        getContentData(code){
            getTopic(code).then(res => {
               this.contentData = res.result.child || [];
               // console.log('this.contentData = ', this.contentData);
            }).catch(err => {
                console.log(err)
            })
        },

    }
}

</script>

<style>
.head_background{
    width:100vw;
    height:60px;
    background-image:url('../../../public/resource/column/column_head_bg.png');
    background-size: 100vw;
    background-position-y: -23.7vw;
    background-repeat: no-repeat;
    position: absolute;
    top: 50px;
    z-index: -1;
}

.head_title{
    width:100vw;
    height:50px;
    text-align: center;
    line-height:50px;
    color:white;
}

.head_search{
    width:100vw;
    height:60px;
    text-align: center;
    line-height:60px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.head_search > .search{
    width: 90vw;
}
.body-box{
    width:100vw;
    height:calc(100vh - 50px - 60px - 50px);
    overflow-y:hidden;
    display: flex;

}

.sidebar{
    width:24vw;
    height:calc(100vh - 50px - 60px - 50px);
    overflow-y: scroll;
    background-color: RGBA(238, 238, 238, 1);
}

.sidebar_item{
    width:24vw;
    height:50px;
    line-height:50px;
    display:flex;
    justify-content: space-between;
    align-items: center;
    position:relative;

}
.sidebar_item_title{
    width:calc(100% - 10px);
    height:20px;
    font-size:16px;
    color:black;
    line-height:20px;
    padding:0 5px;
    text-overflow:ellipsis;
    white-space:nowrap;
    overflow:hidden;
    box-sizing: border-box;
}


.content_box{
    width:76vw;
    height:calc(100vh - 50px - 60px - 60px);
    background-color: RGBA(255, 255, 255, 1);
    overflow: scroll;
    display:flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    padding-left: 2vw;
    box-sizing: border-box;
}

.bottom_guidebar{
    width:100vw;
    height:60px;
    text-align: center;
    line-height:60px;
    position: absolute;
    bottom: 0;
}



</style>
